import React from "react";

export default function ProductionSectionHead({ section }) {
    return (
        <div className="production-section-head">
            <span>{section.label}</span>
            <h2>{section.title}</h2>
            {section.text ? <p>{section.text}</p> : null}
        </div>
    );
}
